@if (!minimized()) {
  @if (showHeader()) {
    <div class="border-b border-gray-200">
      <div class="px-8 h-20 items-center flex gap-3">
        <div class="text-[13px] font-medium tracking-[0.3px] text-headline whitespace-nowrap overflow-hidden text-ellipsis">
          {{ title() }}
        </div>
        <div class="grow"></div>
        @if (listStore.foldersOpen()) {
          <app-context-menu-state-indicator svgIcon="filters" appBoardsFoldersListContextMenu />
        } @else {
          <app-context-menu-state-indicator svgIcon="filters" appBoardsListContextMenu />
        }
      </div>
    </div>
  }

  <!-- The sidebar's "Folders" label: every folder in place of the boards, as Sheets' and Files' "Folders" pages. -->
  @if (listStore.foldersOpen()) {
    <app-boards-folders-list (openFolder)="openFolder.emit($event)" (boardCreated)="folderBoardCreated.emit($event)" />
  } @else {
    <app-list-load-error [error]="loadError()" (retry)="refresh()" />

    @if (items().length === 0 && !loading() && !loadError()) {
      <app-no-content-stub class="grow" imageSrc="assets/placeholders/empty-boards.svg" [size]="75">
        <div class="flex max-w-full flex-col items-center gap-2">
          @if (listStore.isSearchApplied()) {
            <p class="text-base font-medium text-gray-900 text-center">No boards match your search</p>
          } @else if (listStore.view() === 'deleted') {
            <p class="text-base font-medium text-gray-900 text-center">{{ listStore.isFilterApplied() ? NO_MATCH_TITLE : TRASH_EMPTY_TITLE }}</p>
          } @else if (listStore.view() === 'archived') {
            <p class="text-base font-medium text-gray-900 text-center">{{ listStore.isFilterApplied() ? NO_MATCH_TITLE : ARCHIVE_EMPTY_TITLE }}</p>
          } @else {
            <p class="text-base font-medium text-gray-900 text-center">No boards</p>
            <p class="text-sm text-gray-600 text-center">Create a board to get started.</p>
          }
        </div>
      </app-no-content-stub>
    } @else {
      <div
        #scrollableContainer
        class="overflow-y-auto grow basis-0 has-[app-list-items-separator]:scroll-pt-16"
        appSelectableList
        #appSelectableList="appSelectableList"
        [deselectOnReclick]="!drivesPreview()"
        [appSelectableListReset]="resetSelected"
        [appSelectableListItems]="selectableRows()"
        (openSelected)="handleOpenSelected($event)"
      >
        @if (loading() && items().length === 0) {
          <app-loading-indicator [inPanel]="true">Loading boards</app-loading-indicator>
        }

        @for (item of items(); track item.board.id) {
          @if (item.showSectionHeader) {
            <app-list-items-separator [value]="item.section" />
          }
          <app-board-card
            class="block"
            [class.bg-background-highlight]="item.board.pinned || (item.board.flagged && listStore.options().flaggedOnTop)"
            [board]="item.board"
            [position]="$index"
            [showLocationBadge]="listStore.isSearchApplied()"
            [appSelectable]="item.board"
            [appSelectablePosition]="$index"
            [appSelectableIdentifier]="item.board.id"
            [appSelectableListRef]="appSelectableList"
            (appDblClick)="doubleClickBoard.emit(item.board)"
            (click)="handleRowClick($event, item.board.id)"
            (open)="openBoard.emit(item.board)"
          />
        }
      </div>

      <app-list-selection-bar [list]="appSelectableList" />
    }

    <!-- The total is the whole filtered library: it is shown once the current read has every page (R13FIX-SCALE-LIST-R1-1); a failed read offers its retry above. -->
    @if (store.boardsComplete()) {
      <app-pagination2
        class="border-t border-border"
        [page]="listStore.page()"
        (pageChange)="changePage($event)"
        [pageSize]="pageSize"
        [totalItems]="totalCount()"
        (refresh)="refresh()"
      />
    }
  }
}
